var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefund(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.652161,
    width: 42.6957,
    height: 42.6957,
    rx: 8,
    fill: "#EAEAEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3478 26.7826H22.5435C23.3406 26.7826 24.9348 26.3043 24.9348 24.3913C24.9348 22.4783 23.3406 22 22.5435 22H20.1522C19.3551 22 17.7609 21.5217 17.7609 19.6087C17.7609 17.6956 19.3551 17.2174 20.1522 17.2174H21.3478M21.3478 26.7826H17.7609M21.3478 26.7826V29.1739M24.9348 17.2174H21.3478M21.3478 17.2174V14.8261",
    stroke: "#82818C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91904 15.2813L10.9829 18.9545L14.5799 17.6561",
    stroke: "#82818C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1653 18.5104C12.6147 14.2801 16.6261 11.2391 21.3478 11.2391C27.2908 11.2391 32.1087 16.0569 32.1087 22C32.1087 27.943 27.2908 32.7608 21.3478 32.7608C16.0937 32.7608 11.719 28.9953 10.7754 24.0157",
    stroke: "#82818C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefund);
export default __webpack_public_path__ + "static/media/refund.dcbc1c756ae4d8d0c93eecedd57a770c.svg";
export { ForwardRef as ReactComponent };